import { Button, Modal, showAlert } from '@beehive/components';
import React, { useEffect, useState } from 'react';
import './index.less';
import { Dispatch, bindActionCreators } from 'redux';
import {
  getAnnouncementDetail,
  getAnnouncementList,
  updateAnnouncementList,
} from 'containers/OutBidding/api';
import moment from 'moment';
import { NodeEnum, getListPathMenuKey } from 'containers/OutBidding/utils';
import { connect } from 'react-redux';
import { refreshList } from 'modules/actions/bidProjectMove';
import isBlank from 'utils/object';

const formatDate = (v: string) => {
  return moment(v).format('YYYY-MM-DD') || '--';
};

const getTransformData = (data: Record<string, any>) => {
  if (isBlank(data)) return;
  const {
    product_name,
    expect_begin_at,
    expect_end_at,
    name,
    budget,
    bid_registration_deadline,
    bid_proposal_deadline,
    budget_currency_desc,
    bidding_id,
    bidding_supplier_id,
    announcement_content,
    is_willing_invite,
  } = data;
  return {
    orderId: bidding_id,
    biddingSupplierId: bidding_supplier_id,
    title: `${product_name} ${name} 需求比选公告`,
    subtitle: `${product_name} ${formatDate(expect_begin_at)} / ${formatDate(
      expect_end_at
    )} ${name} 需求比选，项目预算${budget}${budget_currency_desc}，
    比选提案日期${formatDate(
      bid_proposal_deadline
    )}，请有意合作供应商于${formatDate(
      bid_registration_deadline
    )}前，接受比选需求，审核通过后可获取详细比选资料。`,
    content: announcement_content,
    accept: is_willing_invite,
  };
};

const AnnouncementModal = (props: any) => {
  const { refreshList, id, onClose } = props;
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [curIndex, setCurIndex] = useState(0);
  const [list, setList] = useState<any>([]);

  const prefixClx = 'announcement-modal';

  const refresh = () => {
    // 如果已在列表弹框, 则刷新
    if (['toDoProcess'].includes(getListPathMenuKey())) {
      refreshList(getListPathMenuKey());
    }
  };

  const getList = async () => {
    const res = await getAnnouncementList({});
    const { data = [] } = res;
    setList(data?.map?.((v: any) => getTransformData(v)));
    if (data.length) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  };

  const getDetail = async () => {
    const res = await getAnnouncementDetail(id).catch(() => {
      // 存在异常情况，需要再主动刷新列表更新状态
      refresh();
    });
    const { data } = res;
    // 结果再弹框，因为有可能 异常
    setVisible(true);
    setList([getTransformData(data)]);
  };

  useEffect(() => {
    if (!isBlank(id)) {
      getDetail();
    } else {
      getList();
    }
  }, [id]);

  const handleCancel = () => {
    setVisible(false);
  };

  const handleOk = () => {
    setVisible(false);
  };

  const handleChangePage = (type: 'next' | 'pre') => {
    if (type === 'pre' && curIndex > 0) {
      setCurIndex(curIndex - 1);
    }
    if (type === 'next' && curIndex < list.length - 1) {
      setCurIndex(curIndex + 1);
    }
  };

  const handleUpdate = (type: 'yes' | 'no') => {
    Modal.confirm({
      title: `确定${type === 'yes' ? '接受' : '不接受'}吗？`,
      onOk: async () => {
        const { orderId, biddingSupplierId, bidding_nda_attachments } = list[curIndex];
        const params: any = {
          id: orderId,
          state: NodeEnum.AWAITING_BIDDING,
          bidding_action: 'SUBMIT',
          pass: true,
          form: {
            bidding_supplier_id: biddingSupplierId,
            nda_blob_ids: bidding_nda_attachments?.map((item: any) => item?.blob?.id)
          },
        };
        if (type === 'yes') {
          params.form.is_willing_invite = true;
        }
        if (type === 'no') {
          params.form.is_willing_invite = false;
        }
        setLoading(true);
        try {
          await updateAnnouncementList(params);
          showAlert({ type: 'success', message: '处理成功' });
          setCurIndex(0);
          if (id) {
            setVisible(false);
            onClose && onClose();
          } else {
            getList();
          }
          refresh();
          // handleChangePage('next');
        } finally {
          setLoading(false);
        }
      },
    });
  };

  const info = list[curIndex];

  const len = list.length;

  const footer = (
    <div className={`${prefixClx}-footer`}>
      <div className={`${prefixClx}-footer-left`}>
        {len > 1 ? `${curIndex + 1} / 共{len}条` : ''}
      </div>
      <div className={`${prefixClx}-footer-right`}>
        {len > 1 && (
          <Button
            disabled={curIndex === 0}
            onClick={() => handleChangePage('pre')}
          >
            上一条
          </Button>
        )}
        {len > 1 && (
          <Button
            disabled={curIndex === len - 1}
            onClick={() => handleChangePage('next')}
          >
            下一条
          </Button>
        )}
        <Button
          onClick={() => handleUpdate('no')}
          loading={loading}
          disabled={loading}
        >
          不接受
        </Button>
        <Button
          type="primary"
          onClick={() => handleUpdate('yes')}
          loading={loading}
          disabled={loading}
        >
          接受
        </Button>
      </div>
    </div>
  );

  return (
    <Modal
      className={prefixClx}
      title="比选公告"
      visible={visible}
      onCancel={handleCancel}
      onOk={handleOk}
      footer={footer}
      width={480}
      maskClosable={false}
      keyboard={false}
    >
      <div className={`${prefixClx}-body`}>
        {info ? (
          <>
            <div className={`${prefixClx}-body-title`}>{info.title}</div>
            <div className={`${prefixClx}-body-subtitle`}>{info.subtitle}</div>
            <div className={`${prefixClx}-body-content`}>
              <div>公告内容：</div>
              <div>{info.content}</div>
            </div>
          </>
        ) : null}
      </div>
    </Modal>
  );
};

export function mapDispatchToProps(dispatch: Dispatch<any>, ownProps: any) {
  return bindActionCreators(
    {
      refreshList,
    },
    dispatch
  );
}

export default connect(null, mapDispatchToProps)(AnnouncementModal);
